import React, { useState, useEffect } from 'react'
import Sidebar from '../../components/Admin/Sidebar'
import AdminHeader from '../../components/Admin/AdminHeader'
import UserBlock from '../../components/Admin/User/UserBlock'
import useStudentsStore from '../../stores/studentsStore'
import useGroupsStore from '../../stores/groupsStore';
import AdminSchedule from '../../components/Admin/AdminSchedule';
import { useNavigate } from 'react-router-dom';
import AdminBottomNavBar from '../../components/Admin/AdminBottomNavBar';

const MONTHS = [
  'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
  'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
];
const EN_MONTHS = [
  'January','February','March','April','May','June',
  'July','August','September','October','November','December'
];

function AdminUsers() {
  const [modalOpen, setModalOpen] = useState(false);
  const [fullName, setFullName] = useState('');
  const [groupId, setGroupId] = useState('');
  const [showScheduleUserId, setShowScheduleUserId] = useState(null);
  const [search, setSearch] = useState('');
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterMonth, setFilterMonth] = useState(() => localStorage.getItem('adminUsersFilterMonth') || '');
  const [filterYear, setFilterYear] = useState(() => localStorage.getItem('adminUsersFilterYear') || '');
  const {
    students, fetchStudents, addStudent, addResult, loading, error, clearAddResult
  } = useStudentsStore();
  const { groups, fetchGroups } = useGroupsStore();
  const navigate = useNavigate();

  useEffect(() => {
    fetchStudents();
    // eslint-disable-next-line
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      await addStudent({ fullName, group: groupId || undefined });
      setFullName(''); setGroupId('');
      await fetchStudents();
    } catch {}
  };

  const handleOpenModal = () => {
    setModalOpen(true);
    clearAddResult();
    setFullName('');
    setGroupId('');
    fetchGroups();
  };

  // Фильтрация по поиску
  const filteredBySearch = students.filter(s => {
    const q = search.trim().toLowerCase();
    if (!q) return true;
    const nameMatch = s.fullName && s.fullName.toLowerCase().includes(q);
    const groupMatch = (Array.isArray(s.groups) && s.groups.some(g => (g.name || '').toLowerCase().includes(q))) || (s.group && s.group.name && s.group.name.toLowerCase().includes(q));
    return nameMatch || groupMatch;
  });

  // Фильтрация по году оплаты
  const filteredByYear = filterYear
    ? filteredBySearch.filter(s => {
        if (!Array.isArray(s.paymentHistory)) return false;
        return s.paymentHistory.some(ph => String(ph.year) === String(filterYear));
      })
    : filteredBySearch;

  // Фильтрация по месяцу неоплаты
  const filtered = filterMonth
    ? filteredByYear.filter(s => {
        if (!Array.isArray(s.paymentHistory)) return false;
        return s.paymentHistory.some(ph => ph.months && ph.months[EN_MONTHS[MONTHS.indexOf(filterMonth)]] === false);
      })
    : filteredByYear;

  return (
    <>
      <div className='AdminUsers'>
        <div className="AdminUsers__container">
          <Sidebar className="admin-sidebar" />
          <div className="content_admin">
            <AdminHeader
              title="Управление учениками"
              textButton="Добавить ученика"
              onButtonClick={handleOpenModal}
            />
            <div className="search" style={{ display: 'flex', gap: 16, alignItems: 'center', marginBottom: 16 }}>
              <input
                type="text"
                placeholder='Поиск по имени или группе'
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={{ width: 260 }}
              />
              <select
                value={filterYear}
                onChange={e => {
                  setFilterYear(e.target.value);
                  localStorage.setItem('adminUsersFilterYear', e.target.value);
                }}
                style={{ padding: '7px 18px', borderRadius: 8, border: '1px solid #ece9f7', fontWeight: 500, fontSize: 15 }}
              >
                <option value=''>Все года</option>
                <option value='2025'>2025</option>
                <option value='2026'>2026</option>
                <option value='2027'>2027</option>
              </select>
              {filterYear && (
                <button
                  onClick={() => {
                    setFilterYear('');
                    localStorage.removeItem('adminUsersFilterYear');
                  }}
                  style={{ background: '#f5f5f5', color: '#222', border: '1px solid #ece9f7', borderRadius: 8, padding: '7px 18px', fontWeight: 500, cursor: 'pointer' }}
                >Сбросить год</button>
              )}
              <button
                onClick={() => setFilterOpen(v => !v)}
                style={{ background: filterMonth ? '#6c3be4' : '#f5f5f5', color: filterMonth ? '#fff' : '#222', border: '1px solid #ece9f7', borderRadius: 8, padding: '7px 18px', fontWeight: 500, cursor: 'pointer' }}
              >
                Фильтр
              </button>
              {filterOpen && (
                <div style={{ position: 'absolute', zIndex: 10, background: '#fff', border: '1px solid #ece9f7', borderRadius: 10, boxShadow: '0 2px 12px #ece9f7', padding: 18, marginTop: 60, minWidth: 220 }}>
                  <div style={{ fontWeight: 600, marginBottom: 10 }}>Не оплачено:</div>
                  <select
                    value={filterMonth}
                    onChange={e => {
                      setFilterMonth(e.target.value);
                      localStorage.setItem('adminUsersFilterMonth', e.target.value);
                    }}
                    style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', marginBottom: 12 }}
                  >
                    <option value=''>Выберите месяц</option>
                    {MONTHS.map((m, i) => <option value={m} key={i}>{m}</option>)}
                  </select>
                  <button onClick={() => setFilterOpen(false)} style={{ background: '#6c3be4', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 16px', fontWeight: 500, cursor: 'pointer', width: '100%' }}>Применить</button>
                  {filterMonth && <button onClick={() => {
                    setFilterMonth('');
                    localStorage.removeItem('adminUsersFilterMonth');
                  }} style={{ marginTop: 8, background: '#f5f5f5', color: '#222', border: '1px solid #ece9f7', borderRadius: 6, padding: '7px 16px', fontWeight: 500, cursor: 'pointer', width: '100%' }}>Сбросить</button>}
                </div>
              )}
            </div>
            <div className="admin-users-table-wrapper">
              <table className="admin-users-table">
                <thead>
                  <tr>
                    <th>ФИО</th>
                    <th>Группа</th>
                    <th>Расписание</th>
                    <th>Подробнее</th>
                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr><td colSpan={4} style={{ textAlign: 'center', color: '#888', padding: 20 }}>Загрузка...</td></tr>
                  )}
                  {!loading && filtered.length === 0 && (
                    <tr><td colSpan={4} style={{ textAlign: 'center', color: '#888', padding: 20 }}>Нет учеников</td></tr>
                  )}
                  {!loading && filtered.map(s => (
                    <tr key={s._id}>
                      <td>{s.fullName}</td>
                      <td>{Array.isArray(s.groups) && s.groups.length ? s.groups.map(g => g.name || g).join(', ') : (s.group && s.group.name ? s.group.name : 'нету')}</td>
                      <td>
                        <button className="admin-users-schedule-btn" onClick={() => navigate(`/admin/user/${s._id}/schedule`)}>
                          Расписание
                        </button>
                      </td>
                      <td>
                        <button className="admin-users-schedule-btn" onClick={() => navigate(`/admin/user/${s._id}/full`)}>
                          Подробнее
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {modalOpen && (
              <div className="admin-users-modal-overlay">
                <div className="admin-users-modal-content">
                  <h3 style={{ marginBottom: 20 }}>Добавить ученика</h3>
                  <form onSubmit={handleAdd}>
                    <div style={{ marginBottom: 16 }}>
                      <label>ФИО:</label>
                      <input value={fullName} onChange={e => setFullName(e.target.value)} required style={{ width: '100%', marginTop: 4 }} />
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label>Группа (необязательно):</label>
                      <select value={groupId} onChange={e => setGroupId(e.target.value)} style={{ width: '100%', marginTop: 4 }}>
                        <option value=''>Без группы</option>
                        {groups.map(g => <option value={g._id} key={g._id}>{g.name}</option>)}
                      </select>
                    </div>
                    {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
                    {addResult && (
                      <div style={{ background: '#f5f5f5', borderRadius: 8, padding: 10, marginBottom: 10 }}>
                        <div><b>Логин:</b> {addResult.login}</div>
                        <div><b>Пароль:</b> {addResult.password}</div>
                      </div>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                      <button type="button" className="admin-users-modal-btn" onClick={() => { setModalOpen(false); clearAddResult(); }}>Отмена</button>
                      <button type="submit" className="admin-users-modal-btn admin-users-modal-btn-primary" disabled={loading}>{loading ? 'Добавление...' : 'Добавить'}</button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <AdminBottomNavBar />
    </>
  );
}

export default AdminUsers